import React, { useEffect, useState } from 'react';
import MapWrapper from '../Components/MapWrapper.jsx'
import SideBar from '../Components/SideBar.jsx'
import MainSideBar from '../Components/MainSideBar.jsx'

import '../Components/MapWrapper.css'
import '../Components/SideBar.css'
import '../Components/FiltersAndLayers.css'
import '../Components/TopBar.css'

import { useSelector,useDispatch } from 'react-redux'
import { selectCanAccess, selectCanDo, selectUserMetadataLoadedInStore } from '../app/auth.js'
import { Navigate,useSearchParams } from 'react-router-dom';
import { projectsApi, selectProjectId, setProjectId } from '../app/projects.js';
import { setLayers } from '../app/layers.js';
import { selectMultipleAnnotations, togglePanel, selectActivePanel, setDisplayedPhoto, setTopbar } from '../app/interface.js';
import { clearCandidateAnnotations, replaceAnnotations, updateAnnotationState, updateViewSpec } from '../app/annotations.js';
import { replaceTextAnnotations } from '../app/textAnnotations.js';
import { getDefaultDocumentTitle } from '../app/branding.js';



function Ortho() {
  const canAccess = useSelector(selectCanAccess)
  const canDo = useSelector(selectCanDo)
  const userMetadataLoadedInStore = useSelector(selectUserMetadataLoadedInStore)
  const [searchParams] = useSearchParams();
  const viewId = searchParams.get("viewId")
  const inspectionId = searchParams.get("inspectionId")
  const dispatch = useDispatch();
  const projectId = useSelector(selectProjectId)
  const [projectIdLocal, setProjectIdLocal] = useState(null) // projectId resolved for this inspection (avoids redirect using projectId from another context)
  const activePanel = useSelector(selectActivePanel)
  const OUTPUTFIELDS = {
    project: `id`
  }

  useEffect(() => {
    // Ortho: open annotate in select mode (SelectionOnGoing), not draw (DefaultForm)
    dispatch(updateAnnotationState("SelectionOnGoing"));
    projectsApi.get({ inspectionId }, OUTPUTFIELDS.project, ({ project }) => {
      dispatch(setProjectId(project.id));
      setProjectIdLocal(project.id);
    });
    return () => {
      setProjectIdLocal(null);
      dispatch(setDisplayedPhoto(null));
      dispatch(setLayers({layers: []}))
      // reset selection array
      dispatch(selectMultipleAnnotations([]))
      // reset annotationState
      dispatch(updateAnnotationState("DefaultForm"));
      // reset candidate annotation array
      dispatch(clearCandidateAnnotations())
      // reset view
      dispatch(updateViewSpec({ spec: { description: { keys: [] } } }))
      // reset annotations
      dispatch(replaceAnnotations([]));
      dispatch(replaceTextAnnotations([]));
      // reset panel
      dispatch(togglePanel({id: "analyse"}))
      dispatch(setTopbar({ title: '' }))
      document.title = getDefaultDocumentTitle()
    }
  }, [inspectionId])

  // Set default panel based on permissions - only enforce security, don't force preferences
  useEffect(() => {
    if (projectId) {
      const canCreateAnnotation = canDo("createAnnotation", {projectId});
      // If user cannot create annotations and is on "annotate", switch to "analyse"
      if (!canCreateAnnotation && activePanel === "annotate") {
        dispatch(togglePanel({id: "analyse"}));
      }
    }
  }, [projectId, activePanel, canDo, dispatch])

  return <div className="full-screen">
    <MapWrapper mode="ortho" />
    <SideBar/>
    <MainSideBar/> 
  </div>
}

export default Ortho
